namespace Solovis.Site.ValueTypes {

    /**
     * Retrieve descriptive label for the value type id.
     * @param valueTypeId
     */
    export function getValueTypeLabel(valueTypeId: number): string {        
        if (Solovis.isNull(valueTypeId)) {
            return "";
        }

        switch (valueTypeId) {
            case 127: return "Actual";
            case 32: return "Third-Party Estimate";
            case 16: return "Computed Estimate";
            case 0: return "Deleted";
        }

        var levelProp = ValueTypes._getCustomizableLevelPropertyName(valueTypeId);
        if (levelProp) {
            // See if there is a custom label defined.
            if ((Solovis as any).Custom && (Solovis as any).Custom.EstimateLevels) {
                var estimateLevels = (Solovis as any).Custom.EstimateLevels;
                if (estimateLevels.labels) {
                    var customLabel = estimateLevels.labels[levelProp];
                    if (customLabel) {
                        return customLabel;
                    }
                }
            }
        }

        if (valueTypeId >= 64 && valueTypeId <= 83) {
            switch (valueTypeId) {
                case 83: return "Estimate Level 20";
                case 82: return "Estimate Level 19";
                case 81: return "Estimate Level 18";
                case 80: return "Estimate Level 17";
                case 79: return "Estimate Level 16";
                case 78: return "Estimate Level 15";
                case 77: return "Estimate Level 14";
                case 76: return "Estimate Level 13";
                case 75: return "Estimate Level 12";
                case 74: return "Estimate Level 11";
                case 73: return "Estimate Level 10";
                case 72: return "Estimate Level 9";
                case 71: return "Estimate Level 8";
                case 70: return "Estimate Level 7";
                case 69: return "Estimate Level 6";
                case 68: return "Estimate Level 5";
                case 67: return "Estimate Level 4";
                case 66: return "Estimate Level 3";
                case 65: return "Estimate Level 2";
                case 64: return "Estimate Level 1";
            }
        }

        return valueTypeId.toString();
    }


    export function _getCustomizableLevelPropertyName(valueTypeId: number): string {
        if (!valueTypeId)
            return null;

        var levelProp = null;

        switch (valueTypeId) {
            case 83: levelProp = "level20"; break;
            case 82: levelProp = "level19"; break;
            case 81: levelProp = "level18"; break;
            case 80: levelProp = "level17"; break;
            case 79: levelProp = "level16"; break;
            case 78: levelProp = "level15"; break;
            case 77: levelProp = "level14"; break;
            case 76: levelProp = "level13"; break;
            case 75: levelProp = "level12"; break;
            case 74: levelProp = "level11"; break;
            case 73: levelProp = "level10"; break;
            case 72: levelProp = "level9"; break;
            case 71: levelProp = "level8"; break;
            case 70: levelProp = "level7"; break;
            case 69: levelProp = "level6"; break;
            case 68: levelProp = "level5"; break;
            case 67: levelProp = "level4"; break;
            case 66: levelProp = "level3"; break;
            case 65: levelProp = "level2"; break;
            case 64: levelProp = "level1"; break;
        }

        return levelProp;
    }


    export function _isCustomLevelEnabled(valueTypeId: number): boolean {
        var valueTypeIdForEstimateLevel1 = 64;
        var valueTypeIdForEstimateLevel3 = 66;
        var valueTypeIdForEstimateLevel20 = 83;

        if (valueTypeId >= valueTypeIdForEstimateLevel1 && valueTypeId <= valueTypeIdForEstimateLevel20) {
            var levelProp = ValueTypes._getCustomizableLevelPropertyName(valueTypeId);
            if (levelProp) {
                if ((Solovis as any).Custom && (Solovis as any).Custom.EstimateLevels) {
                    var customLevels = (Solovis as any).Custom.EstimateLevels;
                    if (customLevels.enabled) {
                        var levelEnabled = customLevels.enabled[levelProp];
                        if (Solovis.isNotNull(levelEnabled)) {
                            return levelEnabled ? true : false;
                        }
                    }
                }
            }
        }

        if (valueTypeId >= valueTypeIdForEstimateLevel1 && valueTypeId <= valueTypeIdForEstimateLevel3) {
            // By default, Estimate Levels 1 - 3 are enabled.
            return true;
        }

        return false;
    }


    export function getValueTypeOptions(
        activeValueTypeId: number
    ): { text: string, value: number }[] {
        var valueTypeOptions = [];

        var addOption = function (valueTypeId) {
            valueTypeOptions.push({
                text: ValueTypes.getValueTypeLabel(valueTypeId),
                value: valueTypeId
            });
        };

        // "Computed Estimate"
        addOption(16);

        // "Third-Party Estimate"
        addOption(32);

        // See which of the customizable estimate levels we need to add (Estimate Level 1-20)
        var valueTypeIdForEstimateLevel1 = 64;
        for (var i = 1; i <= 20; i++) {
            var valueTypeIdForLevel = valueTypeIdForEstimateLevel1 + i - 1;

            if (activeValueTypeId == valueTypeIdForLevel || ValueTypes._isCustomLevelEnabled(valueTypeIdForLevel)) {
                addOption(valueTypeIdForLevel);
            }
        }

        // "Actual"
        addOption(127);

        return valueTypeOptions;
    }
}
